import { generateHTML } from '@tiptap/html';
import { buildSopExtensions } from './sopExtensions';
import { flattenStepContent } from '../../../utils/sopContent';

/** A valid empty Tiptap document. */
export const EMPTY_DOC = { type: 'doc', content: [{ type: 'paragraph' }] };

/** True when the doc has no meaningful content (blank paragraphs / empty steps). */
export function isEmptyDoc(json) {
  if (!json || !Array.isArray(json.content) || json.content.length === 0) return true;
  let hasText = false;
  const walk = (node) => {
    if (!node) return;
    if (node.type === 'text' && (node.text || '').trim()) {
      hasText = true;
      return;
    }
    (node.content || []).forEach(walk);
  };
  json.content.forEach(walk);
  return !hasText;
}

/**
 * Render SOP Tiptap JSON to static HTML for the PDF export. Runs in the browser
 * off the same schema the editor uses, so the PDF always matches what's on
 * screen. Node views are ignored by generateHTML (renderHTML is used instead),
 * yielding semantic <section><h3>…</h3><div>…</div></section> markup.
 */
export function sopJsonToHtml(json) {
  try {
    // Flatten any older step-format doc first so it fits the plain schema.
    return generateHTML(flattenStepContent(json || EMPTY_DOC), buildSopExtensions({ mode: 'static' }));
  } catch (err) {
    console.error('Failed to render SOP JSON to HTML:', err);
    return '';
  }
}
